/**
 * Nsoul Ventures logo — preserved brand identity.
 * Uses the actual brand PNGs (tagline removed). Do not modify visual identity.
 * variant: "navy" (default) — for light backgrounds
 * variant: "light" — for dark backgrounds (navy → white, gold preserved)
 */
export default function Logo({ variant = "navy", className = "", size = "md", testId = "logo" }) {
  const src = variant === "light" ? "/brand/nsoul_logo_light.png" : "/brand/nsoul_logo.png";
  const heights = {
    sm: "h-10 md:h-11",
    md: "h-12 md:h-[54px]",
    lg: "h-16 md:h-[72px]",
    xl: "h-24 md:h-28",
  };
  return (
    <img
      src={src}
      alt="Nsoul Ventures"
      draggable={false}
      className={`select-none ${heights[size] || heights.md} w-auto object-contain ${className}`}
      data-testid={testId}
    />
  );
}
